import { createContext } from "react";

export type WeekViewCardPlacement = "stacked" | "timed" | "all-day";

export const WeekViewContext = createContext<WeekViewCardPlacement>("stacked");